export enum StorageKey {
  RetailerOverviewMainFilters = 'ri_storeRetailerOverviewMainFilters',
  OpportunityReviewMainFilters = 'ri_storeOpportunityReviewMainFilters',
  ProductsMainFilters = 'ri_storeProductsMainFilters',
  TradingMainFilters = 'ri_storeTradingMainFilters',
  SideFilters = 'ri_storeFilterSettings',
  UserData = 'ri_userData',
  RetailerClient = 'ri_storeRetailerClient',
  HitlistsRetailerClient = 'ri_storeHitlistsRetailerClient',
  RetailKadClient = 'ri_retailKadClient',
  MarketPremiumRetailerClient = 'ri_storeMarketPremiumRetailerClient',
  SellerInsightsRetailerClient = 'ri_storeSellerInsightsRetailerClient',
  MarketPremiumMainFilters = 'ri_storeMarketPremiumMainFilters',
  MultiCountryLatestTimeFrame = 'ri_storeMultiCountryLatestTimeFrame',
  CompareProductsData = 'ri_compareProducts',
  PgAvailabilityBasedSingleCountryAndPeriods = 'ri_pgAvailabilityBasedSingleCountryAndPeriods',
  CountryAvailabilityByPeriodAndPg = 'ri_countryAvailabilityByPeriodAndPg',
}

export const getSessionStorage = (key: string) => {
  return sessionStorage.getItem(key);
};

export const setSessionStorage = (key: string, value: string): void => {
  sessionStorage.setItem(key, value);
};

export const deleteSessionStorageByKey = (key: string): void => {
  sessionStorage.removeItem(key);
};

export const deleteSessionStorage = (): void => {
  for (let key in StorageKey) {
    deleteSessionStorageByKey(StorageKey[key as keyof typeof StorageKey]);
  }
};

export const getLocalStorage = (key: string) => {
  return localStorage.getItem(key);
};

export const setLocalStorage = (key: string, value: string): void => {
  localStorage.setItem(key, value);
};

export const deleteLocalStorageByKey = (key: string): void => {
  localStorage.removeItem(key);
};

export const validateLocalStorageByUserData = (key: string | null, isAuthenticated: boolean): boolean => {
  return key === StorageKey.UserData && isAuthenticated;
};
